import React, { useCallback, useRef, useState } from 'react';
import axios from '../../../sagas/axios';
import ModalAlert from '../../../components/modal/modal_alert';
import ModalLoader from '../../../../modal/modal_loader';
import compressImage from '../../../../../lib/image_compressor';

const Edit = ({
  violationReport,
  user,
  violationTypes,
  isApp,
}) => {
  const [option, setOption] = useState(0);
  const [body, setBody] = useState('');
  const [images, setImages] = useState([]);
  const [focused, setFocused] = useState(false);
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onChangeImageData = useCallback(
    async (imageFile) => {
      const compressedFile = await compressImage(imageFile);
      let formData = new FormData();
      formData.append('file', compressedFile);
      formData.append('violation_report_id', violationReport.id);
      axios
        .patch(`/api/violation_reports/upload_image`, formData)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            setImages(response.data);
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [loaderRef, errorRef, violationReport, user]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const data = JSON.stringify({
        violation_report_id: violationReport.id,
        option: option,
        body: body,
        user_id: user.id
      });
      axios
        .post(`/api/violation_reports/users/${user.id}`, data)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      body,
      option,
      user,
      violationReport,
    ]
  );

  const toUserPage = useCallback(() => {
    window && (window.location.href = `/member/profile/${user.tunagate_id}`);
  });

  const violationTypesSelect = violationTypes.map((violationType) => {
    return (
      <option value={violationType.id} key={violationType.id}>
        {violationType.option_wording}
      </option>
    );
  });

  const changeOption = (e) => {
    setOption(e.target.value);
  };

  const onClickImage = () => {
    $('#CreateImage').click();
  }

  // 送信できない理由（見た目のみ。送信ボタンが押せる条件は下の disabled のまま）
  const isExample = !focused && body.length == 0;

  return (
    <div>
      {/* 2026: ユーザーの通報フォーム（画面45）。サークルの通報フォーム（画面81）と双子。見た目は _vr_2026_style（81 と共通） */}
      <main
        style={{ paddingBottom: isApp == false ? '165px' : '66px' }}
        className="vr-2026"
      >
        <div className="vr-container">
          <h1 className="vr-title">ユーザーを通報する</h1>

          {/* 通報する相手。何を通報しているのかが一目で分かるように（81 のサークルの帯と同じ形。ユーザーなのでアイコンは丸）。
              名前はサーバーがプロフィールと同じ決まりで決めた文字列（TGW-3023） */}
          <div className="vr-target">
            <img
              className="vr-target__icon vr-target__icon--round"
              src={user.avatar_thumb}
              alt=""
              onError={(e) => {
                e.target.src = '/images/ja2/img_noimage.gif';
              }}
            />
            <span className="vr-target__body">
              <span className="vr-target__label">通報するユーザー</span>
              <span className="vr-target__name">{user.name}</span>
            </span>
          </div>

          {/* 安心してもらうための一文。相手の帯のすぐ下に、鍵のアイコンつき・グレーの小さな文字で（デザイナー案 2026-10-14） */}
          <p className="vr-privacy">通報した方の個人情報が、相手に伝わることはありません。</p>

          <div className="vr-card">
            <div className="vr-field">
              <p className="vr-label" id="vr-option-label">
                通報理由<span className="vr-tag vr-tag--required">必須</span>
              </p>
              {/* 通報理由はドロップダウン（デザイナー決定 2026-10-14。文言を短くする案とあわせて）。
                  見た目はプロフィール登録の .ue-select と同じ（高さ46px・角丸10px・右に自前の矢印）。
                  「選択してください」は選び直せないように disabled（見た目のみ） */}
              <select
                className={'vr-select' + (option == 0 ? ' is-empty' : '')}
                aria-labelledby="vr-option-label"
                value={option}
                onChange={changeOption}
              >
                <option value={0} key={0} disabled>
                  選択してください
                </option>
                {violationTypesSelect}
              </select>
            </div>

            <div className="vr-field">
              <label className="vr-label" htmlFor="body">
                通報内容の詳細<span className="vr-tag vr-tag--required">必須</span>
              </label>
              <p className="vr-help">
                いつ、どこで、誰に、何をされたかなど、具体的な状況を記入してください。
              </p>
              <div className="vr-textwrap">
                <textarea
                  id="body"
                  className={'vr-textarea' + (isExample ? ' is-example' : '')}
                  onBlur={() => {
                    setFocused(false);
                  }}
                  onFocus={() => setFocused(true)}
                  value={
                    !focused && body.length == 0
                      ? '例）2026年10月10日のイベントに参加した際、主催者の〇〇さんから別のセミナーに勧誘されました。\n断った後も繰り返し勧誘を受け、困りました。'
                      : body
                  }
                  onChange={(e) => setBody(e.target.value)}
                  rows="8"
                />
                {/* 文字数。66 と同じく入力欄の中の右下に常に出す（記入例のあいだも）。1,000 は表示だけの目安で、超えると赤くなるが
                    入力・送信は止めない（本当の上限はサーバー側の決まりが要るのでエンジニアに確認）。最低50文字は送信ボタンの下の案内のまま */}
                <p className={'vr-count' + (body.length > 1000 ? ' is-over' : '')}>
                  {body.length.toLocaleString()} / 1,000
                </p>
              </div>
            </div>

            <div className="vr-field">
              <p className="vr-label">
                状況がわかる画像<span className="vr-tag">任意</span>
                <span className="vr-label__count">（{images.length}/10）</span>
              </p>
              <p className="vr-help">
                勧誘メッセージや不適切な投稿のスクリーンショットなどがあれば、添付してください。
                <br />
                {/* 画像を消す仕組みがまだ無いので、エンジニアが直すまでは注意書きを残す（デザイナー判断 2026-10-14） */}
                ※追加した画像は、あとから削除できません。選ぶ前にご確認ください。
              </p>
              <div className="vr-images">
                {images.map((image) => {
                  if (image.image_url_medium != undefined) {
                    return (
                      <div key={`imageImages_${image.id}`} className="vr-image">
                        <img
                          className="vr-image__img"
                          type="image"
                          id={image.id}
                          src={image.image_url_medium}
                          alt=""
                        />
                      </div>
                    );
                  }
                })}
                {/* 追加の枠は1つだけ（以前は空の枠を10個並べていた）。10枚になったら出さない */}
                {images.length < 10 ? (
                  <a
                    key={`ImageBox_${images.length + 1}`}
                    className="vr-image vr-image--add"
                    role="button"
                    onClick={onClickImage}
                  >
                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/heic, image/heif, .heic, .heif"
                      onChange={(e) => {
                        onChangeImageData(e.target.files[0]);
                      }}
                      name="CreateImage"
                      id="CreateImage"
                      style={{ display: 'none' }}
                    />
                    {/* ＋の丸はアルバム一覧の「アルバムを作成する」（.alb-card__plus）と同じ作りを小さくしたもの */}
                    <span className="vr-image__plus" aria-hidden="true">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
                    </span>
                    <span className="vr-image__addtext">追加</span>
                  </a>
                ) : null}
              </div>
            </div>

            {/* 使い道のお知らせ。フォームの最後、送信ボタンの手前に、盾のアイコンつきのうすい青の箱で（デザイナー案 2026-10-14）。
                文章も画像も届くのは運営だけなので、画像の欄ではなく内容全体に対して書く */}
            <div className="vr-purpose">
              <svg className="vr-purpose__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 3 4.5 6v5.5c0 4.6 3.1 8.3 7.5 9.5 4.4-1.2 7.5-4.9 7.5-9.5V6L12 3Z" /><path d="m8.8 12 2.2 2.2 4.2-4.4" /></svg>
              <p className="vr-purpose__text">
                ご提出いただいた内容は、通報内容の確認および必要な対応のために使用します。
                <br />
                目的以外に使用することはありません。
              </p>
            </div>
          </div>

          <div className="vr-submitwrap">
            <button
              type="button"
              className="vr-submit"
              onClick={(e) => onSubmit(e)}
              disabled={option === 0 || body.length < 50}
            >
              送信する
            </button>
            {option === 0 || body.length < 50 ? (
              <p className="vr-submit__note">通報理由を選び、詳細を50文字以上書くと送信できます</p>
            ) : null}
          </div>
        </div>
      </main>

      <ModalAlert
        ref={successRef}
        name="通報完了"
        content="通報に成功しました。"
        approveFunc={toUserPage}
      />
      <ModalAlert
        ref={errorRef}
        name="通報失敗"
        content="通報に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
